import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { RegisterStepType } from 'src/app/domain/enums/register-step-types.enum';
import { RegisterService } from '../../../../shared/services/register.service';

@Component({
  selector: 'app-second-limit',
  templateUrl: './second-limit.component.html',
  styleUrls: []
})
export class SecondLimitComponent implements OnInit {
  private readonly notifier: NotifierService
  tenant: string = '';
  public loading: boolean;

  constructor(
    private readonly router: Router,
    notifierService: NotifierService,
    private readonly route: ActivatedRoute,
    private readonly registerService: RegisterService,
  ) {
    this.notifier = notifierService;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const result = params.get('tenant');

      if (result)
        this.tenant = params.get('tenant');
    });

  }

  goHome() {
    this.router.navigate([`${this.tenant}/home`]);
  }

  goNext() {
    this.loading = true;
    this.registerService.putRegisterStep(RegisterStepType.SecondLimit).subscribe({
      next: (stepResult) => {
        this.loading = false;
        this.router.navigate([`${this.tenant}/onboardings/company-documents`]);
      },
      error: (err) => {
        this.loading = false;
      },
    });
  }

}
